import React from 'react';
import PropTypes from 'prop-types';
import { FormattedDate } from 'react-intl';

import { DateStyles } from '../../constants/CentricConstants';
import { statusColours } from '../../constants/ColourConstants';
import ROLES from '../../constants/Roles';

import IconButton from 'material-ui/IconButton';
import IconMenu from 'material-ui/IconMenu';
import { Link } from 'react-router';
import { ListItem } from 'material-ui/List';
import { openDialog } from '../../actions/DialogActionCreator';

import DownloadIcon from 'material-ui/svg-icons/file/file-download';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import SkillIcon from 'material-ui/svg-icons/social/public';
import TrainerIcon from 'material-ui/svg-icons/editor/title';
import CertificateIcon from 'material-ui/svg-icons/action/verified-user';
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';

import UserActions from '../../actions/UserActionCreator';

import buildContextMenu from '../Common/BuildContextMenu';
import { UserDialogs } from "../../constants/Dialogs";


const style = {
    menu: {
        marginRight: 0,
        marginBottom: 0,
        float: 'left',
        position: 'relative',
        zIndex: 0,
    },
    menuItem: {
        color: '#CC0000',
    },
    iconButton: {
        marginRight: 0,
        padding: 0
    },
    listItem: {
        padding: '2px',
    },
    icon: {
        height: '32px',
        width: '32px',
    },
    iconSmall: {
        height: '16px',
        width: '16px',
        margin: '2px 8px 0 0',
        padding: 0,
        color: statusColours.medium,
    },
};

const getActions = (userId, skill) => [
    {
        link: `/usr/user/${userId}/certificate/${skill.id}/certificate.pdf`,
        target: '_blank',
        icon: <DownloadIcon />,
        label: 'Download certificate',
        condition: {
            show: (userId && skill.id && !!skill.certificateId)
        }
    },
    {
        action: () => openDialog(UserDialogs.USER_SKILL_DIALOG, {isEdit: true, skill}),
        icon: <EditIcon />,
        label: 'Edit',
        condition: {
            roles: [ROLES.ADMIN]
        }
    },
    {
        type: 'deleteDialog',
        dialogType: 'menu',
        value: skill.id,
        title: 'Delete user skill',
        deleteAction: () => UserActions.removeSkill(userId, skill.skillId),
        message: (<span>Are you sure you wish to remove this skill from this user?</span>),
        condition: {
            roles: [ROLES.ADMIN]
        }
    }
];

const topRight = { horizontal: 'right', vertical: 'top' };
const asContextMenu = (actions) => {

    if(!actions || actions.length < 1) return null;

    return (
            <IconMenu
                menuStyle={style.menu}
                anchorOrigin={topRight}
                targetOrigin={topRight}
                iconButtonElement={(
                    <IconButton touch={true}>
                        <MoreVertIcon color={statusColours.light} style={style.iconButton} />
                    </IconButton>
                )}
            >
                {actions}
            </IconMenu>
    )

};



const UserSkillListItem = ({userId, data}, {auth}) => {

    const infoLink = `/dashboard/skill/${data.skillId}/user/${userId}`;
    const today = new Date();
    let expiredDate = '';
    let iconColor = statusColours.primary;
    let description = '';

    let iconGroup = [];
    if (!!data.isTrainerSkill) {
        iconGroup.push(<TrainerIcon style={style.iconSmall} key="trainer" />);
    }

    if (data.certificateId) {
        iconGroup.push(<CertificateIcon style={style.iconSmall} key="certificate" />);
    }

    const score = (!!data.score) && ` | Score: ${data.score}`;
    const dateAcquired = (<FormattedDate {...DateStyles.short} value={new Date(data.dateAcquired)}/>);

    if (!!data.dateExpired) {
        let expired = new Date(data.dateExpired);
        expiredDate = (<FormattedDate {...DateStyles.short} value={expired}/>);
        if (expired < today) {

            iconColor = statusColours.disabled;
            description = (<span> Expired on {expiredDate} {score}</span>);

        } else if (expired < today.setMonth(today.getMonth() + 1)) {
            description = (<span>Expires on {expiredDate} {score}</span>);
        } else {
            description = (<span>Valid until {expiredDate} {score}</span>);
        }
    } else {
        description = (<span>Acquired on {dateAcquired} {score}</span>);
    }

    const actions = buildContextMenu(getActions(userId, data), auth);

    return (
        <ListItem
            leftAvatar={
                <Link to={infoLink} >
                    <SkillIcon
                    style={style.icon}
                    color={iconColor}/>
                </Link>
            }
            style={style.listItem}
            primaryText={(<Link to={infoLink} className="primaryText">
                            {`${data.skillName} (${data.skillCode})`}
                        </Link>)}
            secondaryText={(
                <Link to={infoLink} className="secondaryText">
                    <em>{description}</em>
                    <br/>
                    {iconGroup} {data.level}
                </Link>
            )}
            secondaryTextLines={2}
            rightIconButton={asContextMenu(actions)}
        />
    );
};

UserSkillListItem.propTypes = {
    userId:     PropTypes.number.isRequired,
    data:       PropTypes.shape({
        id:             PropTypes.number.isRequired,
        skillId:        PropTypes.number.isRequired,
        skillName:      PropTypes.string.isRequired,
        dateAcquired:   PropTypes.string.isRequired,
        dateExpired:    PropTypes.string,
        grade:          PropTypes.string,
        certificateId:  PropTypes.number,
        certificate:    PropTypes.string

    }).isRequired
};

UserSkillListItem.contextTypes = {
    auth:   PropTypes.object
};

export default UserSkillListItem;
